module.exports = __webpack_public_path__ + "img/login.bf4f3ea9.png";